<template>
  <div class="loading-spinner-component pa-4">
    <FulfillingBouncingCircleSpinner
      :animationDuration="2000"
      :size="small ? 24 : 65"
      :color="$vuetify.theme.primary"
    />
    <small v-if="info" class="info-text">
      {{ info }}
    </small>
  </div>
</template>

<script>
import { FulfillingBouncingCircleSpinner } from 'epic-spinners'
export default {
  name: 'LoadingSpinner',
  components: {
    FulfillingBouncingCircleSpinner,
  },
  props: {
    info: String,
    small: Boolean,
  },
}
</script>

<style lang="postcss" scoped>
.loading-spinner-component {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.info-text {
  display: inline-block;
  font-family: var(--font-stylized);
  font-size: var(--fs-title);
  margin-top: 28px;

  &:first-letter {
    text-transform: uppercase;
  }
}
</style>
